import React, { createContext, useState } from 'react';

// Crear el contexto
export const LoginContext = createContext();

// Proveedor del contexto
export const LoginProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  const login = (userData) => {
    setUser(userData); // Guardamos el usuario en el estado
    localStorage.setItem('user', JSON.stringify(userData)); // Guardamos en localStorage para persistencia
    console.log(userData)
  };

  const logout = () => {
    setUser(null); // Borramos el usuario del estado
    localStorage.removeItem('user'); // Quitamos el usuario de localStorage
  };

  // Chequea si el usuario está logueado
  const isAuthenticated = !!user || !!localStorage.getItem('user');

  return (
    <LoginContext.Provider value={{ user, login, logout, isAuthenticated }}>
      {children}
    </LoginContext.Provider>
  );
};
